export default __webpack_public_path__ + "static/skoda~bmKGGKPv-ff7154f9a4f2da5c93481dc964a9d3fd.png";